import { ArrowDown, ArrowUp, ArrowUpDown, ChevronDown, SlidersHorizontal, X } from "lucide-react";
import { useState, type ReactNode } from "react";
import { cx } from "../lib/cx";
import { Button } from "./ui";

export function FilterPanel({
  search,
  children,
  activeCount = 0,
  totalLabel,
  onClear,
  defaultOpen = false,
  title = "فیلترهای پیشرفته",
}: {
  search?: ReactNode;
  children: ReactNode;
  activeCount?: number;
  totalLabel?: ReactNode;
  onClear?: () => void;
  defaultOpen?: boolean;
  title?: string;
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <section className={cx("filter-panel", open && "is-open")}>
      <div className="filter-panel__bar">
        <div className="filter-panel__search">{search}</div>
        <div className="filter-panel__summary">
          {totalLabel ? <div className="toolbar__count">{totalLabel}</div> : null}
          {onClear && activeCount > 0 ? (
            <Button type="button" variant="ghost" className="filter-panel__clear" onClick={onClear}>
              <X size={15} /> پاک‌کردن
            </Button>
          ) : null}
          <button
            type="button"
            className="filter-panel__toggle"
            aria-expanded={open}
            onClick={() => setOpen((value) => !value)}
          >
            <SlidersHorizontal size={17} />
            <span>{title}</span>
            {activeCount > 0 ? <b>{activeCount.toLocaleString("fa-IR")}</b> : null}
            <ChevronDown className="filter-panel__chevron" size={16} />
          </button>
        </div>
      </div>
      <div className="filter-panel__collapse" aria-hidden={!open} inert={!open ? true : undefined}>
        <div className="filter-panel__fields">{children}</div>
      </div>
    </section>
  );
}

export function SortableHeader({
  label,
  value,
  ascValue,
  descValue,
  onChange,
  defaultDirection = "asc",
  className,
}: {
  label: string;
  value: string;
  ascValue?: string;
  descValue?: string;
  onChange: (value: string) => void;
  defaultDirection?: "asc" | "desc";
  className?: string;
}) {
  const isAsc = Boolean(ascValue && value === ascValue);
  const isDesc = Boolean(descValue && value === descValue);
  const isActive = isAsc || isDesc;

  const nextValue = () => {
    if (isAsc && descValue) return descValue;
    if (isDesc && ascValue) return ascValue;
    if (defaultDirection === "desc" && descValue) return descValue;
    return ascValue ?? descValue ?? value;
  };

  const Icon = isAsc ? ArrowUp : isDesc ? ArrowDown : ArrowUpDown;
  const sortState = isAsc ? "ascending" : isDesc ? "descending" : "none";

  return (
    <th className={className} aria-sort={sortState}>
      <button
        type="button"
        className={cx("sortable-header", isActive && "is-active")}
        onClick={() => onChange(nextValue())}
        title={`مرتب‌سازی بر اساس ${label}`}
      >
        <span>{label}</span>
        <Icon size={14} />
      </button>
    </th>
  );
}
